import { Uniformly, FieldStatus, TextField, EmailField, PhoneField } from '@livefree/uniformly';

export const RegistrationForm = ({ onChange }) => {
  return (
    <Uniformly name="registration" onChange={onChange} className="flex flex-col gap-1">
      <FieldStatus required className="w-full">
        <TextField
          name="displayUser"
          value=""
          validation={x => x.string().required('Display name is required')}
          label="Display Name"
        />
      </FieldStatus>
      <FieldStatus required className="w-full">
        <TextField
          name="firstName"
          value=""
          validation={x => x.string().required('First name is required')}
          label="First Name"
        />
      </FieldStatus>
      <FieldStatus required className="w-full">
        <TextField
          name="lastName"
          value=""
          validation={x => x.string().required('Last name is required')}
          label="Last Name"
        />
      </FieldStatus>
      <FieldStatus required className="w-full">
        <EmailField
          name="email"
          value=""
          required
          label="Email"
          validationMessage="Email address is not valid"
          requiredMessage="Email address is required"
        />
      </FieldStatus>
      <FieldStatus important className="w-full">
        <PhoneField name="phoneNumber" value="" label="Phone #" />
      </FieldStatus>
    </Uniformly>
  );
};
